"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMetrics = calculateMetrics;
exports.getBarChartDataDataSet = getBarChartDataDataSet;

var _utils = require("./utils");

function calculateMetrics(_ref) {
  var registered = _ref.registered,
      anonymous = _ref.anonymous;
  var totalCount = registered.count + anonymous.count;
  var totalPreviousCount = registered.previousCount + anonymous.previousCount;
  var totalPercentageDifference = (0, _utils.previousPeriodDifference)(totalCount, totalPreviousCount);
  var anonymousPercentageDifference = (0, _utils.previousPeriodDifference)(anonymous.count, anonymous.previousCount);
  var registeredPercentageDifference = (0, _utils.previousPeriodDifference)(registered.count, registered.previousCount);
  return {
    total: {
      count: totalCount,
      previousCount: totalPreviousCount,
      percentageDifference: totalPercentageDifference
    },
    anonymous: {
      count: anonymous.count,
      previousCount: anonymous.previousCount,
      percentageDifference: anonymousPercentageDifference
    },
    registered: {
      count: registered.count,
      previousCount: registered.previousCount,
      percentageDifference: registeredPercentageDifference
    }
  };
}

function getBarChartDataDataSet(data) {
  var labels = [];
  var registered = [];
  var anonymous = [];
  data.forEach(function (d) {
    labels.push(d.time);
    registered.push(d.registered_count);
    anonymous.push(d.anonymous_count);
  });
  return {
    labels: labels,
    datasets: [{
      label: 'Registered',
      fill: false,
      data: registered,
      borderColor: _utils.BRAND_BLUE,
      backgroundColor: _utils.BRAND_BLUE
    }, {
      label: 'Guest',
      fill: false,
      data: anonymous,
      borderColor: _utils.BRAND_YELLOW,
      backgroundColor: _utils.BRAND_YELLOW
    }]
  };
}